import React from 'react';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { Theme } from 'models/Theme/Theme';
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import i18n from 'i18next';
import {
    headerTunables,
    opacityTunables,
    overflowTunables,
} from 'components/Sidebar/RenderTunables/SharedTunables';
import {
    gridTunables,
    metaInfoTunables,
    xAxisTunables,
    yAxisTunables,
} from 'components/Sidebar/RenderTunables/HyperspaceSharedTunables';
import ActionSliderGroup from 'components/_UI/Forms/Actions/ActionSliderGroup';

export const HyperSpaceColumnChartWidgetTunables = (
    widget: Widget,
    mergedTheme: Theme
): TunablesCollapse[] => [
    {
        props: {
            label: i18n.t('Column Chart'),
            startOpen: true,
        } as CollapseProps,
        children: [
            ...headerTunables(widget),
            opacityTunables(widget),
            overflowTunables(widget),
            gridTunables(widget),
            <ActionSliderGroup
                key='columnWidth'
                label={i18n.t('Column Width')}
                showValue
                option={widget.options}
                value='columnWidth'
                min={25}
                max={150}
            />,
        ],
    },
    metaInfoTunables({ widget, color: true, image: true }),
    xAxisTunables({ widget, format: false, mergedTheme }),
    yAxisTunables({ widget, axisIsDim: false }),
];
